<div class="top-margin-5 pb-4 d-flex justify-content-center align-items-center">
    <div *ngIf="!currentUser.permissions.isHMPClient" class="h-50 w-50 p-3 mx-auto bg-white">
        <div class="font-huge text-red d-flex justify-content-center">
            <i class="fas fa-check"></i>
        </div>
        <div class="font-big text-gray font-weight-bold text-center">SUCCESS</div>
        <div class="text-center"><b class="review-sub-header">Your campaign has been submitted for review.</b></div>

        <div *ngIf="currentUser.permissions.isLearfieldClient" class="text-gray text-center">The EDGE team will review your campaign to make sure everything is ok.</div>
        <div *ngIf="currentUser.permissions.isHSClient" class="text-gray text-center">Our admins will review your campaign to make sure everything is ok.</div>
        <div class="text-gray text-center">Once the campaign is approved, you will receive an email.</div>
        <div *ngIf="currentUser.permissions.isHSClient" class="mt-5 d-flex justify-content-center align-items-center">
            <button (click)="openUploadNewCRM()" pButton class="btn edge-flat-btn" label="UPLOAD CRM"></button>
        </div>

        <div [ngClass]="currentUser.permissions.isLearfieldClient ? 'mt-5' : ''" class="d-flex justify-content-center align-items-center">
            <button (click)="goHome()" pButton class="btn edge-no-button" [label]="currentUser.permissions.isHSClient? 'EXIT TO HOME' : 'Exit to home'"></button>
        </div>
    </div>
    <div id="printArea" class="h-150 w-50 mx-auto bg-white edge-border" *ngIf="currentUser.permissions.isHMPClient">
        <div class="font-huge pb-3 text-red d-flex justify-content-center print-only-logo">
            <img style="width: 15%;" src="../../../../../../assets/HUB_PoweredbyEDGE_Layers_rev2.png" />
        </div>
        <div class="h-30 w-40 p-3 mx-auto success-background">

            <div class="font-big text-white font-weight-bold text-center">SUCCESS</div>
            <div class="text-center"><b class="review-sub-header">Your campaign has been submitted for review.</b></div>

            <div class="text-white text-center" style="font-size: 10px;">The EDGE team will review your assets for approval. Following approval, an email notification will be sent.</div>
        </div>
        <div class="d-flex justify-content-center align-items-center font-bigger mt-3"><b>Order Summary</b> </div>
        <div class="row px-5" *ngIf="campaignDto">
            <div class="col-12">
                <hr />
            </div>
            <div class="col col-lg-6 col-md-6 col-sm-12 mt-3">
                <div class="row justify-content-between mb-3">
                    <div class="col-sm-12 col-md-5 font-weight-bold">Campaign Name</div>
                    <div class="col-sm-12 col-md-7">{{ campaignDto.name }} </div>
                </div>

                <div class="row justify-content-between mb-3">
                    <div class="col-sm-12 col-md-5 font-weight-bold">Campaign Dates</div>
                    <div class="col-sm-12 col-md-7"> <label>{{(campaignDto.startDate) | date : constants.DEFAULT_FORMAT_DATE_US }}</label>
                        - <label>{{(campaignDto.endDate) | date : constants.DEFAULT_FORMAT_DATE_US }}</label></div>
                </div>
                <div class="row justify-content-between mb-3">
                    <div class="col-sm-12 col-md-5 font-weight-bold">Invoice Number</div>
                    <div class="col-sm-12 col-md-7">{{ campaignDto.billingInvoiceNumber }}</div>
                </div>
                <div class="row justify-content-between mb-3">
                    <div *ngIf="paymentData.isCard" class="col-sm-12 col-md-5 font-weight-bold edge-border">Credit Card</div>
                    <div *ngIf="!paymentData.isCard" class="col-sm-12 col-md-5 font-weight-bold edge-border">Bank Account</div>

                    <div class="col-sm-12 col-md-7">{{ paymentData.paymentData | creditCardMask}}</div>
                </div>

                <div id="invisible" class="mt-5">
                    <a class="link font-weight-bold" (click)="redirectSA()">EDGE's Service Agreement</a>
                </div>
            </div>

            <div class="col col-lg-6 col-md-6 col-sm-12">
                <campaign-costs-table id="visibleOnPrint" [isPrint]="isPrint" [baseCampaign]="campaignDto"></campaign-costs-table>
                <campaign-costs-table id="invisible" [baseCampaign]="campaignDto"></campaign-costs-table>
            </div>
        </div>
        
        <div id="invisible" class="px-5 pb-3">
            <div class="print-left-wrapper">
                <button id="invisible" type="button" pButton (click)="print(); " [attr.title]="" class="edge-no-button" label="Print Order"> </button>
            </div>
            <div class="d-flex flex-row-reverse flex-wrap bd-highlight mt-3 mb-3">               
                <!-- <div class="py-2 pr-2 bd-highlight"><button type="button" pButton class="flat-btn" label="Back"></button></div> -->
                <div class="py-2 pl-2 bd-highlight"><button type="button" pButton (click)="createNewCampaign()" [attr.title]="" class="edge-button" label="Create New Campaign"> </button></div>
                <div [ngClass]="'pl-2'" class="py-2 bd-highlight"><button type="button" pButton (click)="openUploadNewCRM()" [attr.title]="" class="edge-button" label="Upload CRM"></button></div>
                <div class="py-2 bd-highlight"><button type="button" pButton class="edge-no-button px-4 " (click)="cancel()" label="Exit"></button></div>

            </div>
        </div>

    </div>
</div>
<app-upload-crm-modal *ngIf="uploadNewCRMModalState" (closeDialog)="handleCloseDialog()"></app-upload-crm-modal>
